// date strings for the function dateFormat will live
export var weekDay = 'EEE';
export var monthDayYear = 'MMMM d, yyyy';
export var weekDayMonthDay = 'EEE, MMMM d';
export var longWeekDayMonthDay = 'EEEE, MMMM d';
export var monthDay = 'MMMM d';
